import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import styles from './styles.module.scss';
import Modal from '@cp/src/components/Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import cx from 'classnames';
import CopyToClipboardIcon from '@cp/src/assets/icons/CopyToClipboardIcon';
import { copyToClipboard } from '@cp/src/utils/commonUtils';
import { Button } from '@navi/web-ui/lib/primitives';
import { useEffect, useState } from 'react';
import { getAttributesByTenant } from '@cp/pages/Paramount/paramountActions';
import useGetTenant from '@cp/pages/Paramount/hooks/useGetTenant';
import apiHelper, { ApiKeys, getApiUrl } from '@cp/utils/ApiHelper';
import axiosInstance from '@cp/utils/ApiHelper';

interface ActionsModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

interface Actions {
  label: string;
  value: string;
}

const ActionsModal = (props: ActionsModalProps) => {
  const { isOpen, setIsOpen } = props;

  const tenant = useGetTenant();
  const [actions, setActions] = useState<Actions[]>([]);
  const fetchActions = () => {
    const url = getApiUrl(ApiKeys.PARAMOUNT_FETCH_ACTIONS);
    axiosInstance
      .get(url, {
        headers: {
          'X-Tenant-Ref-Id': tenant.referenceId,
          'X-NAVI-CORRELATION-ID': 'test',
          'x-api-key': tenant.apiKey
        }
      })
      .then(res => {
        const actions = Object.keys(res?.data).map((key, value) => {
          return { label: key, value: res?.data[key] };
        });
        setActions(actions);
      });
  };

  useEffect(() => {
    fetchActions();
  }, []);

  const ActionsCard = (action: Actions) => {
    return (
      <div className="w-[100%] relative flex flex-row my-[20px] py-[20px] bg-greyscale-extra-light">
        <div className="flex justify-between gap-[100px] px-[20px] w-[100%]">
          <div className="flex flex-col gap-[10px]">
            <div className="flex flex-row items-center gap-[8px]">
              <Typography variant="h3">Action : </Typography>
              <Typography variant="p2"> {action?.label}</Typography>
              <Button variant="text" onClick={() => copyToClipboard(action?.label)}>
                <CopyToClipboardIcon width={16} height={16} />
              </Button>
            </div>
            <div className="flex flex-row items-center gap-[8px]">
              <Typography variant="h3">Description : </Typography>
              <Typography variant="p2">{action?.value}</Typography>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <Modal
      visible={isOpen}
      headerClassName={'bg-[#f1f9f9] rounded'}
      onClose={() => setIsOpen(false)}
      header={'All Actions'}
      iconButtonSize="small"
    >
      {actions.length ? (
        <div className="w-[700px] h-[600px] overflow-auto">
          <div className="py-[20px]">
            {actions?.map(action => (
              <ActionsCard {...action} key={action?.label} />
            ))}
          </div>
        </div>
      ) : (
        <div className="px-[20px]">
          <Typography variant={'p4'}>No Attributes Found</Typography>
        </div>
      )}
    </Modal>
  );
};
export default ActionsModal;
